/** 是否签署EULA枚举 */
export enum IsSignedEulaE {
    NOT = 'false',
    YES = 'true'
}

/** 是否支持EULA签署及查看 */
export enum IsSupportEulaE {
    NOT = 'false',
    YES = 'true'
}

/** 是否需要签署EULA */
export enum IsNeedSignE {
    NOT = 'false',
    YES = 'true'
}
